'use strict';

angular.module('amexReconciliationApp')
  .service('ActiveTransactionModel', function (ModelFactory,
                                               $rootScope,
                                               LockStatusService,
                                               TransactionsModel) {
    var activeTransactionModel = ModelFactory.create('ActiveTransactionModel', [
      'activeTransaction',
      'receipts',
      'historyRecords'
    ]);

    activeTransactionModel.clearActiveTransaction = function () {
      activeTransactionModel.activeTransaction(null);
    };

    activeTransactionModel.hasActiveTransaction = function () {
      return !!activeTransactionModel.activeTransaction();
    };

    activeTransactionModel.setActiveTransaction = function (transaction) {

      activeTransactionModel.activeTransaction(transaction);
      return transaction;
    };

    activeTransactionModel.activeTransactionIsFullyLocked = function () {
      return LockStatusService.isLocked(activeTransactionModel.activeTransaction());
    };

    activeTransactionModel.activeTransactionIsPartiallyLocked = function () {
      return LockStatusService.isPartiallyLocked(activeTransactionModel.activeTransaction());
    };

    activeTransactionModel.setActiveTransactionId = function (transactionId) {
      if(!transactionId) { return; }

      var newActiveTransaction = _.find(TransactionsModel.transactions(), { id: transactionId });
      return activeTransactionModel.setActiveTransaction(newActiveTransaction);
    };

    activeTransactionModel.isTransactionReallocated = function(){
      return _.get(activeTransactionModel.activeTransaction(),'mutableTransactionProperties.transactionStatus') === 'REALLOCATED';
    };

    TransactionsModel.onTransactionsChanged($rootScope, function (newTransactions) {
      var newActiveTransaction;
      var transactionId;

      if (activeTransactionModel.hasActiveTransaction()) {
        transactionId = activeTransactionModel.activeTransaction().id;
        newActiveTransaction = _.find(newTransactions, { id: transactionId });
        return activeTransactionModel.setActiveTransaction(newActiveTransaction);
      }
    });

    return activeTransactionModel;
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/ActiveTransactionModel.js
// module id = 570
// module chunks = 0